import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import {
  selectCreditCard,
  selectCreditCardIdFromRoute,
  selectCreditCardPermissions,
  selectDeletingCreditCardFromState,
} from 'src/app/DeactivateBudget/redux/deactivateBudget.selectors'
import ConfirmationPopupContent from 'src/components/ConfirmationPopupContent/ConfirmationPopupContent'
import NotFoundPopupContent from 'src/components/NotFoundPopupContent/NotFoundPopupContent'
import Popup from 'src/components/Popup/Popup'
import { useFlyoutDispatch } from 'src/hooks'
import { useTranslate } from 'src/localization/Trns'
import { useDeactivateCreditCard } from 'src/queries/creditCards/deactivateCreditCard/deactivateCreditCard.queries'
import {
  getCreditCard,
  getCreditCardPermissions,
} from 'src/redux/actions/data/creditCards.actions'

const DeactivateBudget: React.FC = () => {
  const translate = useTranslate()

  const creditCardId = useSelector(selectCreditCardIdFromRoute)
  const creditCard = useSelector(selectCreditCard)
  const creditCardPermissions = useSelector(selectCreditCardPermissions)
  const deletingCreditCard = useSelector(selectDeletingCreditCardFromState)
  const { analytics } = useAnalyticsContext()

  const dispatch = useFlyoutDispatch()
  const deactivateCreditCardMutation = useDeactivateCreditCard()
  const showDeactivateDeleteButton =
    creditCard !== undefined &&
    creditCard.isBudget &&
    creditCardPermissions?.canDestroy

  useEffect(() => {
    dispatch(getCreditCard(creditCardId))
    dispatch(getCreditCardPermissions(creditCardId))
  }, [creditCardId])

  return (
    <Popup>
      {showDeactivateDeleteButton ? (
        <ConfirmationPopupContent
          title={translate('Deactivate')}
          subtitle={translate('Deactivate the budget ${budgetName}?', {
            budgetName: <span>{creditCard.truncatedDisplayName}</span>,
          })}
          actionButtonLabel={translate('Deactivate')}
          actionButtonLoading={deletingCreditCard}
          actionButtonOnClick={(): void => {
            analytics?.track('confirm deactivate budget', {
              budget_id: creditCard.id,
              issuer: creditCard.issuer,
            })
            deactivateCreditCardMutation.mutate({
              creditCardId: creditCard.id,
              creditCard,
            })
          }}
          cancelButtonLabel={translate('Cancel')}
        />
      ) : (
        <NotFoundPopupContent />
      )}
    </Popup>
  )
}

export default DeactivateBudget
